<script>
const { VUE_APP_API_HOST } = process.env

export default {
  methods: {
    listCategories() {
      return this.$http
        .get(`${VUE_APP_API_HOST}/categories`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('user-token')}`
          }
        })
        .then(res => res, err => err)
    },

    saveCategory(body) {
      return this.$http
        .post(`${VUE_APP_API_HOST}/categories`, body, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('user-token')}`
          }
        })
        .then(res => res, err => err)
    },

    updateCategory(data) {
      const { id, ...body } = data

      return this.$http
        .put(`${VUE_APP_API_HOST}/categories/${id}`, body, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('user-token')}`
          }
        })
        .then(res => res, err => err)
    },

    deleteCategory(id) {
      return this.$http
        .delete(`${VUE_APP_API_HOST}/categories/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('user-token')}`
          }
        })
        .then(res => res, err => err)
    }
  }
}
</script>